import Immutable from 'immutable';

const Link = Immutable.Record({
  id: 0,
  type: 'link',
  title: '',
  images: Immutable.List(),
  host: '',
  description: '',
  viewType: '',
  requestedUrl: '',
  url: ''
});

export default Link;



// WEBPACK FOOTER //
// ./src/models/link.js